import type { PushPublicKeyResponse, PushSubscriptionRequest, PushSubscriptionResponse } from '../../types/api';
import { apiFetch, apiRequest } from './client';

export function fetchPushPublicKey(): Promise<PushPublicKeyResponse> {
  return apiFetch<PushPublicKeyResponse>('/api/push/public-key');
}

export function savePushSubscription(subscription: PushSubscriptionRequest): Promise<PushSubscriptionResponse> {
  return apiFetch<PushSubscriptionResponse>('/api/push-subscriptions', {
    method: 'POST',
    body: JSON.stringify(subscription),
  });
}

export function deletePushSubscription(id: string): Promise<void> {
  return apiRequest(`/api/push-subscriptions/${encodeURIComponent(id)}` as `/api/${string}`, {
    method: 'DELETE',
  });
}

export function browserSubscriptionToRequest(subscription: PushSubscription): PushSubscriptionRequest {
  const json = subscription.toJSON();
  const keys = json.keys;
  if (!json.endpoint || !keys?.p256dh || !keys.auth) {
    throw new Error('Invalid push subscription');
  }

  return {
    endpoint: json.endpoint,
    keys: {
      p256dh: keys.p256dh,
      auth: keys.auth,
    },
    user_agent: navigator.userAgent,
    platform: detectPushPlatform(),
  };
}

function detectPushPlatform(): string {
  const ua = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) return 'ios';
  if (/android/.test(ua)) return 'android';
  if (/macintosh|mac os x/.test(ua)) return 'macos';
  if (/windows/.test(ua)) return 'windows';
  return 'web';
}
